import { Button, Card, CardContent, CardHeader, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import { CustomDescrypt } from 'global/func';
import { postDataWithResponse } from 'global/postFunc';
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore';

const PeringkatOpd = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [loading, setLoading] = useState(false)

    const [listOpd, setListOpd] = useState([])
    const [listOpdSortedFisik, setListOpdSortedFisik] = useState([])
    const [listOpdSortedKeuangan, setListOpdSortedKeuangan] = useState([])
    const [listOpdSortedKeuanganPersen, setListOpdSortedKeuanganPersen] = useState([])

    const reqRealisasiOpd = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/sa/peringkat-realisasi-opd',
            {
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res = []) => {
                setListOpd(res)
                setListOpdSortedFisik(res.sort((a, b) => (b.realisasi_fisik - a.realisasi_fisik)))
                setListOpdSortedKeuangan(res.sort((a, b) => (b.realisasi_keuangan - a.realisasi_keuangan)))
                setListOpdSortedKeuanganPersen(res.sort((a, b) => (b.realisasi_keuangan_persen - a.realisasi_keuangan_persen)))
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }


    useEffect(() => {
        reqRealisasiOpd()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log(listOpd);

    }, [listOpd])

    return (
        <Grid container spacing={3} mb={3}>
            <Grid item xs={12} md={12} lg={6}>
                <Card>
                    <CardHeader
                        title="Peringkat Realisasi Fisik"
                    />
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>OPD</TableCell>
                                    <TableCell>Realisasi Fisik</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listOpdSortedFisik.slice(0, 10).map((row) => (
                                    <TableRow key={row.kd_pd} >
                                        <TableCell component="th" scope="row">
                                            {row.kd_pd} {row.nama_pd}
                                        </TableCell>
                                        <TableCell align="right">
                                            {row.realisasi_fisik} %
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <Button fullWidth variant='text'>Selengkapnya</Button>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
                <Card>
                    <CardHeader
                        title="Peringkat Realisasi Keuangan"
                    />
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>OPD</TableCell>
                                    <TableCell>Realisasi Keuangan</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listOpdSortedKeuanganPersen.slice(0, 10).map((row) => (
                                    <TableRow key={row.kd_pd} >
                                        <TableCell>
                                            {row.kd_pd} {row.nama_pd}
                                        </TableCell>
                                        <TableCell>
                                            Rp.{row.realisasi_keuangan.toLocaleString('id-ID')}({row.realisasi_keuangan_persen}%)
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <Button fullWidth variant='text'>Selengkapnya</Button>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Card>
                    <CardHeader
                        title="Komposisi Capaian Realisasi Fisik"
                    />
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>OPD</TableCell>
                                    <TableCell>Blm Terlaksanan</TableCell>
                                    <TableCell>Proses</TableCell>
                                    <TableCell>Selesai</TableCell>
                                    <TableCell>Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listOpdSortedKeuanganPersen.slice(0, 10).map((row) => (
                                    <TableRow key={row.kd_pd} >
                                        <TableCell>
                                            {row.kd_pd} {row.nama_pd}
                                        </TableCell>
                                        <TableCell>
                                            {row.belum_terlaksana}({row.belum_terlaksana_persen}%)
                                        </TableCell>
                                        <TableCell>
                                            {row.proses}({row.proses_persen}%)
                                        </TableCell>
                                        <TableCell>
                                            {row.selesai}({row.selesai_persen}%)
                                        </TableCell>
                                        <TableCell>
                                            {row.total_komponen}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <Button fullWidth variant='text'>Selengkapnya</Button>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

export default PeringkatOpd